module.exports = __webpack_public_path__ + "img/Gallery_2_31.f1ec66b3.jpeg";